import { useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { type TabItemId } from '@sg/garnish';

import { CUSTOMIZATIONS_TABS } from '../../../../../../constants';

export const useProductDetailsIngredientsTabs = () => {
  const { formatMessage } = useIntl();

  const [activeTabItemId, setActiveTabItemId] = useState<TabItemId>(
    CUSTOMIZATIONS_TABS.ADD_INGREDIENTS,
  );

  const tabs = [
    {
      id: CUSTOMIZATIONS_TABS.ADD_INGREDIENTS,
      label: formatMessage(messages.addIngredients),
      panelId: CUSTOMIZATIONS_TABS.ADD_INGREDIENTS,
    },
    {
      id: CUSTOMIZATIONS_TABS.REVIEW,
      label: formatMessage(messages.review),
      panelId: CUSTOMIZATIONS_TABS.REVIEW,
    },
  ];

  return { activeTabItemId, tabs, setActiveTabItemId };
};

// ─── Messages ───────────────────────────────────────────────────────────────

const messages = defineMessages({
  addIngredients: {
    defaultMessage: 'Add ingredients',
    description: 'Product Details | Ingredients | Add ingredients | Tab Label',
  },
  review: {
    defaultMessage: 'Review',
    description: 'Product Details | Ingredients | Review | Tab Label',
  },
});
